import React from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useLocation, Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  /** Omit on the current page — rendered as plain text, not a link. */
  path?: string;
}

interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
  showHome?: boolean;
}

// Route to label mapping
const routeLabels: Record<string, string> = {
  '/': 'Tổng quan',
  '/users': 'Người dùng',
  '/merchants': 'Nhà hàng',
  '/orders': 'Đơn hàng',
  '/categories': 'Danh mục',
  '/vouchers': 'Vouchers',
  '/analytics': 'Phân tích',
  '/settings': 'Cài đặt',
  '/payment-methods': 'Phương thức thanh toán',
};

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  showHome = true,
}) => {
  const location = useLocation();

  // If custom items provided, use them
  if (items && items.length > 0) {
    const breadcrumbItems = showHome
      ? [
          {
            title: (
              <Link to="/">
                <HomeOutlined /> Trang chủ
              </Link>
            ),
          },
          ...items.map(item => ({
            title: item.path ? (
              <Link to={item.path}>{item.label}</Link>
            ) : (
              item.label
            ),
          })),
        ]
      : items.map(item => ({
          title: item.path ? (
            <Link to={item.path}>{item.label}</Link>
          ) : (
            item.label
          ),
        }));

    return <Breadcrumb items={breadcrumbItems} />;
  }

  // Auto-generate from current path
  const pathSnippets = location.pathname.split('/').filter(i => i);
  const breadcrumbItems = [
    ...(showHome
      ? [
          {
            title: (
              <Link to="/">
                <HomeOutlined /> Trang chủ
              </Link>
            ),
          },
        ]
      : []),
    ...pathSnippets.map((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
      const label = routeLabels[url] || url.replace('/', '');
      return {
        title:
          index === pathSnippets.length - 1 ? (
            <span>{label}</span>
          ) : (
            <Link to={url}>{label}</Link>
          ),
      };
    }),
  ];

  return <Breadcrumb items={breadcrumbItems} />;
};
